<div 
  class="modal-overlay" 
  *ngFor="let error of errors; trackBy: trackByErrorId"
  [@slideIn]
>
  <div [class]="getModalClass(error.type)">
    <div class="modal-header">
      <span class="modal-icon">{{ getErrorIcon(error.type) }}</span>
      <span class="modal-title">{{ getErrorTitle(error.type) }}</span>
      <button 
        class="close-btn" 
        (click)="closeError(error.id)"
        type="button"
        aria-label="Close"
      >
        ×
      </button>
    </div>
    <div class="modal-body">
      <p>{{ error.message }}</p>
    </div>
  </div>
</div>
